import {
  SubDivisionsList,
  SubDivisionsCreate,
  SubDivisionsEdit,
} from './views';

export { SubDivisionContainer } from './containers';
export type { SubDivisionFormValues, SupervisorOption } from './containers';

export default {
  create: SubDivisionsCreate,
  edit: SubDivisionsEdit,
  list: SubDivisionsList,
  name: 'subdivision',
  label: 'Subdivisions',
  to: '/subdivision',
};
